import { Outlet } from "react-router-dom";
import { TopNav } from "./top-nav";
import { Sidebar, SidebarProvider } from "./sidebar";

export function AppLayout() {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen flex-col">
        <TopNav />
        <div className="flex flex-1">
          <Sidebar />
          <main className="min-w-0 flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
